<template>
  <div class="market-login-page">
    <header class="market-login-page__header">
      <div class="market-login-page__header-inner">
        <a href="/marketplace" class="market-login-page__brand">
          <span class="market-login-page__brand-mark">RS</span>
          <span class="market-login-page__brand-copy">
            <span class="market-login-page__brand-eyebrow">Enterprise Access</span>
            <span class="market-login-page__brand-title">AI智能体市场</span>
          </span>
        </a>
        <div class="market-login-page__header-links">
          <a
            class="market-login-page__header-link"
            href="https://hub.grapps.cn/docs/"
            target="_blank"
            rel="noopener noreferrer"
          >
            使用文档
          </a>
          <a class="market-login-page__header-link" href="/marketplace">
            返回市场
          </a>
        </div>
      </div>
    </header>

    <main v-if="isLoginRoute" class="market-login-page__login-main">
      <section class="market-login-page__login-shell">
        <div class="market-login-page__login-copy">
          <span class="market-login-page__eyebrow">Enterprise Console</span>
          <h1 class="market-login-page__title">欢迎登录</h1>
          <p class="market-login-page__desc">
            使用企业账号进入应用市场后台。
          </p>
        </div>

        <div class="market-login-page__panel market-login-page__panel--login">
        <div class="market-login-page__panel-inner">
          <router-view />
        </div>
        </div>
      </section>
    </main>

    <main v-else class="market-login-page__secondary">
      <router-view />
    </main>

    <app-footer :isTheme="false"></app-footer>
  </div>
</template>

<script>
export default {
  name: 'LayoutLogin',
  computed: {
    isLoginRoute() {
      return this.$route.name === 'login';
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/styles/login-shell.scss';
</style>



// WEBPACK FOOTER //
// src/views/layout/LayoutLogin.vue